module.exports = __webpack_public_path__ + "static/img/weather33.b8a8d86b.png";